module.exports = __webpack_public_path__ + "media/images/icons/right-arrow-eucalyptus-5c01ee532f8ca2099e2aee1b739b5dd3.svg";